export default __webpack_public_path__ + "static/media/kartu-5.6b79ecce.jpg";